module.exports = __webpack_public_path__ + "static/bathroom2-1672e49784fcf19c9c3bd7788d11b582.jpg";